import i18next from 'i18next';

i18next.addResources('es_CL', 'CallCenterOrderSetup', {
  addAddress: 'Agregar dirección',
  savedAddress: 'Direcciones guardadas',
  register: 'Registrado',
  guest: 'Invitado',
  lastOrderAddress: 'Ultima dirección'
});
